import List from '@utils/list'
import Select from '@utils/common/select'

const { Search, Jurisdiction, Table } = List

// const { Select } = Search

// const select = Select.copy('/purchaseUnit/getPurchaseUnitPage').params({ usingFlag: '1' })

const search = new Search('qualitycollaboration.returndetails')
  .placeholder('searchPlaceholder')
  .add('orderType').op('orderType')
  // .add('purchaseUnitNo').select(select)
  .lib('dateRange').label('dateRange').prop(['purReturnDateStart', 'purReturnDateEnd']).br()
  .add('goodsNo')
  .add('goodsName')
  .add('spec')
  .add('purchaseUnitName')
  .select(Select.use('/purchaseUnit/getPurchaseUnitPage').params({ usingFlag: '1' }))

const jurisdiction = new Jurisdiction()
  .lib('manual').access('/sysQuartzJob/runPurchaseReturnJob', process.env.VUE_APP_SCHEDULE_API)

const table = new Table('qualitycollaboration.returndetails')
  .type('index')
  .add('purchaseReturnNo').width(150).sort(true).label('returnNo')
  .add('purchaseReturnDate').date().sort(true).label('docDate')
  .add('purchaseUnitName').sort(false)
  .add('orderType').op('orderType').sort(false)
  .add('payTermsName').sort(false)
  .add('tranConditonName').sort(false)
  .add('purchaseNo').width(150).sort(false)
  .add('currencyName').sort(false)
  .add('exchangeRate').sort(false).label('taxRate')
  .lib('remarks').sort(false)
  .add('sanlian').sort(false).html(({ row }) => `${row.purchaseSeq}-${row.purchasePhaseSeq}-${row.purchaseBatchSeq}`)
  .add('goodsNo').sort(false)
  .add('goodsName').sort(false)
  .add('spec').sort(false)
  .add('purchaseReturnQty').sort(false)
  .add('valuationQty').sort(false)
  .add('unitName').sort(false).label('purUnitName').format(data => `${data.row.unitNo}-${data.row.unitName}`).width(80)
  .add('taxPrice').sort(false).label('unitPrice')
  .add('noTaxAmount').sort(false).label('preTaxAmount')
  .add('taxAmount').sort(false).label('taxIncludedAmount')
  .add('diffAmount').sort(false).label('taxAmount')
  .add('taxName').sort(false).label('taxTypeName')
  .add('taxRate').sort(false).label('taxRateBody')
  .add('purchaseReturnReason').sort(false).label('returnReason')

export default new List()
  .url('/srmPurReturn/getPurReturnBody', process.env.VUE_APP_PURCHASE_API)
  .jurisdiction(jurisdiction)
  .search(search)
  .table(table)
  .end()
